export default function () {
  return [
    {
      title: '年份',
      [$field]: 'signUpYear',
      width: 80
    },
    {
      title: '全量表单名称',
      [$field]: 'basicFormTypeName',
      width: 100
    },
    {
      title: '姓名',
      [$field]: 'fillInUserName'
    },
    {
      title: '曾报名过的评优申报奖项',
      [$field]: 'signUphistory'
    }
  ]
}
